// import originAxios from 'axios';
import axios from '../axios';

// 获取图文课程的tab列表
export function encyclopediaEntryType(params) {
  return axios.get('hs_encyclopedia/1.0/encyclopedia_entry_type', params);
}

// 获取图文tab下的分页详情
export function encyclopediaEntryPage(params) {
  return axios.get('hs_encyclopedia/1.0/encyclopedia_entry_page', params);
}

// 访问次数记录
export function encyclopediaEntryVisitTimes(params) {
  return axios.post('hs_encyclopedia/1.0/encyclopedia_entry_visit_times', params);
}
